import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function VehicleModelRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/vehicle-model', component: Index, isProtected: true, permissions: ['vehicle_model_index']},
    {path: '/vehicle-model/create', component: Create, isProtected: true, permissions: ['vehicle_model_create']},
    {path: '/vehicle-model/edit/:id', component: Edit, isProtected: true, permissions: ['vehicle_model_edit']},

  ];

  return routes;
}
